import { render, staticRenderFns } from "./PaysPage.vue?vue&type=template&id=ceec49fc&"
import script from "./PaysPage.vue?vue&type=script&lang=ts&"
export * from "./PaysPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports